import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAuthUser } from 'features/auth/AuthUserContext';
// import BlackFridayGlobalBanner from 'components/BlackFridayGlobalBanner';
import WinterSaleBanner from './WinterSaleBanner';
// import NewYearResolutionsBanner from './NewYearResolutionsBanner';

export default function Page({ Component, pageProps }) {
  const router = useRouter();
  const { user, isLoading } = useAuthUser();

  // useEffect(() => {
  //   function handleIntercomStart() {
  //     const help = router.asPath.includes('#help');
  //
  //     setTimeout(
  //       () => {
  //         if (window.Intercom) {
  //           window.Intercom('boot', {
  //             app_id: 'gvophsej',
  //             api_base: 'https://api-iam.intercom.io',
  //             email: user.email,
  //             user_id: user.id,
  //           });
  //           help && window.Intercom('show');
  //         }
  //       },
  //       help ? 100 : 5500,
  //     );
  //   }
  //
  //   if (!isLoading && user?.id) {
  //     handleIntercomStart();
  //   }
  // }, [user, isLoading]);

  useEffect(() => {
    const help = router.asPath.includes('#help');
    if (!help) return;

    // Auto-open mtg-chatbot when URL contains #help
    function openMtgChatbot() {
      try {
        const chatbot = document.querySelector('mtg-chatbot');
        if (chatbot && chatbot.shadowRoot) {
          const bubble = chatbot.shadowRoot.querySelector('.mtg-bubble');
          if (bubble) {
            bubble.click();
            return true;
          }
        }
        return false;
      } catch (e) {
        console.error('Failed to open MTG chatbot:', e);
        return false;
      }
    }

    const timer = setTimeout(() => {
      if (openMtgChatbot()) return;

      // If chatbot not ready yet, wait for it
      var debounceTimer;
      const observer = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          if (openMtgChatbot()) observer.disconnect();
        }, 100);
      });

      observer.observe(document.body, { childList: true, subtree: false });
      setTimeout(() => {
        clearTimeout(debounceTimer);
        observer.disconnect();
      }, 10000);
    }, 1000);

    return () => clearTimeout(timer);
  }, [router.asPath]);

  return (
    <>
      {/* <BlackFridayGlobalBanner customBackgroundColor="#000" /> */}
      {/* <WinterSaleBanner /> */}
      {/* <NewYearResolutionsBanner /> */}
      <Component {...pageProps} />
    </>
  );
}
